import React from 'react'
import {
    SidebarChannel,
} from './types'
import {SidebarChannelsView} from './SidebarChannelsView'
import {
    getRealmChannels,
} from '../../selectors/ninchat'
import {navigation} from '../../navigation'
import {useAppSelector} from '../../hooks'

const SidebarChannels = ({realm_id}: {realm_id: string}): React.ReactElement => {
    const channels = useAppSelector(({ninchat}): Array<SidebarChannel> => {
        const channelList = realm_id ? getRealmChannels(ninchat, realm_id) : []
        return channelList.map((item: SidebarChannel): SidebarChannel => ({...item}))
    })

    const loadChannel = (channel_id: string): void => {
        navigation.push('Channel', {channel_id})
    }

    const loadChannelSettings = (channel_id: string): void => {
        navigation.push('ChannelSettings', {channel_id})
    }

    return (
        <SidebarChannelsView
            channels={channels}
            loadChannel={loadChannel}
            loadChannelSettings={loadChannelSettings}
        />
    )
}

export default SidebarChannels
